import getStore from "./store/store";

export function getUserPremiumStatus(): boolean {
    return getStore().userPremiumStatus;
}
